import React from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';
import { FaCarAlt } from 'react-icons/fa';

const VehicleForm = ({ isActive, formData, handleChange, handlePrev, handleNext }) => {
    return (
        <div id="arac-form" className={isActive ? 'd-block' : 'd-none'}>
            <h4 className="form-section-title">
                <FaCarAlt className="me-2" /> Araç Bilgileri
            </h4>

            <Row className="mb-4">
                <Col md={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>Tercih Ettiğiniz Araç Markası</Form.Label>
                        <Form.Control
                            type="text"
                            name="preferredVehicleBrand"
                            value={formData.preferredVehicleBrand}
                            onChange={handleChange}
                            placeholder="Örn: Toyota, Mercedes"
                        />
                    </Form.Group>
                </Col>

                <Col md={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>Tercih Ettiğiniz Araç Modeli</Form.Label>
                        <Form.Control
                            type="text"
                            name="preferredVehicleModel"
                            value={formData.preferredVehicleModel}
                            onChange={handleChange}
                            placeholder="Örn: Corolla, C180"
                        />
                    </Form.Group>
                </Col>

                <Col md={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>Tercih Ettiğiniz Model Yılı</Form.Label>
                        <Form.Control
                            type="text"
                            name="vehicleYear"
                            value={formData.vehicleYear}
                            onChange={handleChange}
                            placeholder="Örn: 2023, 2022-2024 arası"
                        />
                    </Form.Group>
                </Col>

                <Col md={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>Peşinat Miktarı (₺)</Form.Label>
                        <Form.Control
                            type="number"
                            name="downPayment"
                            value={formData.downPayment}
                            onChange={handleChange}
                            placeholder="Ödeyebileceğiniz peşinat miktarı"
                            min="0"
                        />
                    </Form.Group>
                </Col>
            </Row>

            <div className="d-flex justify-content-between">
                <Button variant="outline-secondary" onClick={handlePrev}>
                    Geri Dön
                </Button>
                <Button variant="primary" onClick={handleNext}>
                    Devam Et
                </Button>
            </div>
        </div>
    );
};

export default VehicleForm;